<template>
    <div class="container-fluid p-0">
        <div class="controls-wrapper">
            <div
                class="counter mt-5 mt-sm-0"
                v-if="this.$route.params.mapType === 'defect'"
            >
                <button
                    id="popover-target-1"
                    @click="onOpenPoppover"
                    class="gm-control-active gm-fullscreen-control custom-gmap-button"
                >
                    <font-awesome-icon
                        :icon="['fas', 'calculator']"
                        size="sm"
                    />
                </button>
                <b-popover
                    target="popover-target-1"
                    triggers="click"
                    placement="bottom"
                >
                    <template v-slot:title
                    >Sumár
                    </template
                    >

                    <div v-for="(summ, color) in summary" :key="color">
                        <img :src="summ.icon" alt="" width="15"/>
                        {{ summ.total }} ks
                    </div>
                </b-popover>
            </div>
            <switchboards
                @input="filterRvo"
                :markers="markers"
                v-if="$can(`${this.permissionsPrefix}.switchboards`)"
            ></switchboards>
            <div class="search-wrapper">
                <autocomplete
                    v-if="markers.length"
                    :markers="markers"
                    @input="filterMarkers"
                ></autocomplete>
            </div>

            <div class="buttons" style="float: right">
                <button
                    title="Zobraziť aktuálnu pozíciu"
                    type="button"
                    class="gm-control-active gm-fullscreen-control custom-gmap-button"
                    v-on:click="geolocation()"
                >
                    <font-awesome-icon
                        :icon="['fas', 'crosshairs']"
                        size="lg"
                        v-if="!geolocating"
                    />
                    <font-awesome-icon
                        :icon="['fas', 'spinner']"
                        spin
                        size="lg"
                        v-if="geolocating"
                    />
                </button>
                <br/>
                <button
                    title="Reset"
                    type="button"
                    class="gm-control-active gm-fullscreen-control custom-gmap-button"
                    v-on:click="resetMap()"
                >
                    <font-awesome-icon :icon="['fas', 'sync']" size="sm"/>
                </button>
                <br/>
                <button
                    title="Prepnúť typ mapy"
                    type="button"
                    class="gm-control-active gm-fullscreen-control custom-gmap-button"
                    v-on:click="
                        mapTypeId =
                            mapTypeId === 'roadmap' ? 'satellite' : 'roadmap'
                    "
                >
                    <span>
                        <img
                            :src="
                                `/img/${
                                    mapTypeId === 'roadmap'
                                        ? 'satellite'
                                        : 'roadmap'
                                }.jpg`
                            "
                            class="left-button-image"
                        />
                    </span>
                </button>
            </div>
        </div>

        <gmap-map
            :center="center"
            :zoom="zoom"
            @zoom_changed="zoomChnaged"
            @center_changed="centerChanged"
            @idle="sync"
            style="width:100%;  height: calc(100vh - 80px)"
            :options="{
                fullscreenControl: false,
                mapTypeControl: false
            }"
            :map-type-id="mapTypeId"
        >
            <gmap-info-window
                :options="{
                    pixelOffset: {
                        width: 3,
                        height: -32
                    }
                }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
                @closeclick="infoWindow.open = false"
            >
                <div class="card mb-3 border-0" style="max-width: 840px;">
                    <div class="row no-gutters">
                        <div
                            class="col-md-7"
                            v-if="$can(`${this.permissionsPrefix}.photo`)"
                        >
                            <a
                                :href="infoWindow.template.photo"
                                target="_blank"
                            >
                                <img
                                    :src="infoWindow.template.photo"
                                    class="card-img"
                                    alt="..."
                                />
                            </a>
                        </div>
                        <div class="col-md-5">
                            <div class="card-body">
                                <h5
                                    class="card-title"
                                    v-if="
                                        $can(`${this.permissionsPrefix}.title`)
                                    "
                                >
                                    {{
                                        infoWindow.template.point_type_id === 1
                                            ? "Svetelný bod č."
                                            : "Rozvádzač č."
                                    }}
                                    {{ infoWindow.template.name }}
                                </h5>
                                <div
                                    v-if="
                                        $can(
                                            `${this.permissionsPrefix}.passport`
                                        )
                                    "
                                >
                                    <p
                                        class="card-text"
                                        v-html="infoWindow.template.description"
                                    ></p>
                                    <p
                                        class="card-text"
                                        v-html="infoWindow.template.solution"
                                    ></p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 mt-4">
                            <b-button-group class="d-lg-flex">
                                <b-button
                                    variant="outline-info"
                                    @click="navigateTo()"
                                    class="w-100"
                                >
                                    <font-awesome-icon
                                        :icon="['fas', 'spinner']"
                                        spin
                                        size="sm"
                                        v-if="geolocating"
                                    />
                                    <font-awesome-icon
                                        :icon="['fas', 'location-arrow']"
                                        size="sm"
                                        v-if="!geolocating"
                                    />
                                    Navigovať
                                </b-button>
                                <b-button
                                    variant="outline-danger"
                                    class="w-100"
                                    :to="{
                                                name: 'reportdefect',
                                                params: { city: 'senec', point: infoWindow.template.name }
                                            }"
                                >
                                    <font-awesome-icon
                                        :icon="['fas', 'exclamation-triangle']"
                                        size="sm"
                                    />
                                    Nahlásiť poruchu
                                </b-button>
                                <b-button
                                    variant="outline-success"
                                    class="w-100"
                                    :to="{
                                                name: 'defectsHistoryDetail',
                                                params: { id: infoWindow.template.id }
                                            }"
                                >
                                    <font-awesome-icon
                                        :icon="['fas', 'chart-bar']"
                                        size="sm"
                                    />
                                    Štatistika bodu
                                </b-button>
                            </b-button-group>
                        </div>
                    </div>
                </div>
            </gmap-info-window>
 
            <gmap-info-window
                :options="{
                    pixelOffset: {
                        width: 3,
                        height: -32
                    }
                }"
                :position="tooltipWindow.position"
                :opened="tooltipWindow.open"
            >
                <div class="card mb-3 border-0" style="max-width: 840px;">
                    {{ tooltipWindow.title }}
                </div>
            </gmap-info-window>

            <gmap-marker
                :key="index"
                v-for="(marker, index) in result"
                :position="{
                    lat: parseFloat(marker.lat),
                    lng: parseFloat(marker.lng)
                }"
                :icon="marker.icon"
                :zIndex="marker.zIndex"
                :label="
                    marker.switchgear
                        ? { text: marker.switchgear, fontSize: '8px' }
                        : null
                "
                @click="openInfoWindowTemplate(marker)"
                @mouseover="previewPoint(marker, true)"
                @mouseout="previewPoint(marker, false)"
            ></gmap-marker>

            <gmap-marker
                v-if="this.currentLocation.lat != 0"
                :position="this.currentLocation"
                :animation="2"
            ></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
import api from "@/store/api"
import Autocomplete from "./Autocomplete"
import Switchboards from "./Switchboards"
import { bus } from "../../main"

export default {
    name: "GoogleMap",
    components: { Switchboards, Autocomplete },
    props: {
        latCenter: Number,
        lngCenter: Number,
    },
    data() {
        return {
            center: { lat: this.latCenter, lng: this.lngCenter },
            centerDefault: { lat: this.latCenter, lng: this.lngCenter },
            reportedMapCenter: { lat: this.latCenter, lng: this.lngCenter },
            markers: [],
            summary: [],
            marker: null,
            result: [],
            currentPlace: null,
            search: "",
            defaultZoom: 13,
            zoom: 13,
            infoWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                template: "",
            },
            tooltipWindow: {
                position: { lat: 0, lng: 0 },
                open: false,
                title: "",
            },
            permissionsPrefix: "map.basic",
            currentLocation: { lat: 0, lng: 0 },
            geolocating: false,
            mapTypeId: "roadmap",
        }
    },

    mounted() {
        this.setMarkers()
        this.setPermissionsPrefix()
    },
    updated() {
        // if(this.$route.params.point) {
        //     let urlPoint = this.$route.params.point.replace(',', '');
        //     this.filterMarkers(urlPoint);
        // }
    },

    methods: {
        onOpenPoppover: function() {
            api.get(`/markers/summary/${this.$route.params.mapType}`).then(
                response => {
                    this.summary = response.data
                },
            )
        },
        zoomChnaged: function(zoom) {
            this.zoom = zoom
        },
        centerChanged: function(center) {
            this.reportedMapCenter = center
        },
        sync: function() {
            this.center = this.reportedMapCenter
        },
        setMarkers: function() {
            api.get(`/markers/${this.$route.params.mapType}`).then(response => {
                this.markers = response.data
                this.result = response.data
                if (this.$route.params.point) {
                    this.filterMarkers(this.$route.params.point)
                }
            })
        },

        filterRvo(value) {
            this.infoWindow.open = false
            this.zoom = this.defaultZoom
            if (!value.length) {
                this.result = this.markers
                return
            }
            bus.$emit("resetSearch")

            this.result = this.markers.filter(marker => {
                return value.indexOf(marker.id) >= 0
            })
        },

        filterMarkers(value) {
            if (value == "") {
                this.result = this.markers
                // this.zoom = 13;
                this.infoWindow.open = false
                return
            }

            this.result = this.markers.filter(marker => {
                return marker.name.replace("/", "") === value.replace("/", "")
            })

            this.reportedMapCenter = this.center = this.getCoordinates(
                this.result[0],
            )
            this.openInfoWindowTemplate(this.result[0])
            this.zoom = 17
        },

        openInfoWindowTemplate(item) {
            this.marker = item

            api.get(
                `/markers/${item.id}/detail/${this.$route.params.mapType}`,
            ).then(response => {
                let marker = response.data
                this.infoWindow.template = marker
                this.infoWindow.position = this.getCoordinates(item)
                this.infoWindow.open = true
                this.tooltipWindow.open = false
            })
        },

        previewPoint(item, open) {
            this.tooltipWindow.position = this.getCoordinates(item)
            this.tooltipWindow.open = open
            this.tooltipWindow.title = item.name
        },

        getCoordinates(marker) {
            return {
                lat: parseFloat(marker.lat),
                lng: parseFloat(marker.lng),
            }
        },
        setPermissionsPrefix() {
            switch (this.$route.params.mapType) {
                case "defect":
                    this.permissionsPrefix = "map.technic"
                    break
                case "rescue":
                    this.permissionsPrefix = "map.rescue"
                    break
                default:
                    this.permissionsPrefix = "map.basic"
                    break
            }
        },
        geolocation: function(navigate = false) {
            this.geolocating = true
            var self = this
            return new Promise((resolved) => {
                navigator.geolocation.getCurrentPosition(
                    position => {
                        if(navigate) {
                            this.currentLocation = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            }
                        }else{
                            this.currentLocation = this.center = this.reportedMapCenter = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            }
                            this.zoom = 18
                        }

                        self.geolocating = false
                        resolved(this.currentLocation);
                    },
                    function(e) {
                        self.geolocating = false
                    },
                    { enableHighAccuracy: true, maximumAge: 10000 },
                )
            })
        },
        navigateTo() {
            this.geolocation(true).then((data) => {
                let routeData = `https://www.google.com/maps/dir/${data.lat},${data.lng}/${this.infoWindow.position.lat},${this.infoWindow.position.lng}/`;
                window.open(routeData, '_blank');
            });
        },
        resetMap: function() {
            this.center = this.reportedMapCenter = this.centerDefault
            this.zoom = this.defaultZoom
            this.infoWindow.open = false
            this.result = this.markers
            bus.$emit("resetSwitchboard")
            bus.$emit("resetSearch")
        },
    },

    watch: {
        "$route.params": {
            handler(newValue, oldValue) {
                if (oldValue !== undefined) {
                    this.$route.params.mapType = newValue.mapType
                    this.setPermissionsPrefix()
                    this.setMarkers()
                    this.infoWindow.open = false
                }
            },
            immediate: true,
        },
    },
}
</script>

<style>
html,
body,
.container-fluid,
#map_canvas {
    height: 100%;
}

.container-fluid {
    width: 100%;
    position: absolute;
    top: 0;
    padding: 0;
}

#map_canvas {
    border-top: 50px solid #fff;
    border-bottom: 20px solid #fff;
}

.custom-gmap-button {
    background: none rgb(255, 255, 255);
    border: 0px;
    margin: 0 10px;
    padding: 0px;
    /*position: absolute;*/
    cursor: pointer;
    user-select: none;
    border-radius: 2px;
    height: 40px;
    width: 40px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    overflow: hidden;
    /*top: 0px;*/
    /*right: 0px;*/
    z-index: 99;
}

.controls-wrapper {
    position: absolute;
    z-index: 99;
    padding-top: 10px;
    width: 100%;
    height: 1px;
}

.search-wrapper {
    float: left;
    text-align: center;
    width: calc(100% - 180px);
    margin-left: 120px;
}

.left-button-image {
    max-width: 100%;
}

.counter {
    position: absolute;
    top: 10px;
    left: 0;
    width: 180px;
    z-index: 99999;
}

@media only screen and (max-width: 576px) {
    .search-wrapper {
        margin-left: 10px;
        text-align: left;
        width: calc(100% - 70px);
    }

    .autocomplete-results {
        margin: 0 !important;
    }
}
</style>
